import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { isMacOs } from "../../constants.js";
/* empty css          */
const MODIFIER = Object.freeze({
  Meta: "Meta",
  Ctrl: "Ctrl",
  Alt: "Alt",
  Shift: "Shift",
  Enter: "Enter"
});
const MAC_DISPLAY = {
  Meta: "⌘",
  Ctrl: "⌃",
  Alt: "⌥",
  Shift: "⇧",
  Enter: "⏎"
};
const NON_MAC_DISPLAY = {
  Meta: "Ctrl",
  Enter: "⏎"
};
const KeycapHint = (t0) => {
  const $ = c(6);
  const {
    keys,
    ariaLabel
  } = t0;
  const display = isMacOs ? MAC_DISPLAY : NON_MAC_DISPLAY;
  let t1;
  if ($[0] !== keys) {
    let t22;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = (k, i) => /* @__PURE__ */ jsx("kbd", { className: "graphiql-keycap", children: /* @__PURE__ */ jsx("span", { className: "graphiql-keycap-glyph", children: display[k] ?? k }) }, `${k}-${i}`);
      $[2] = t22;
    } else {
      t22 = $[2];
    }
    t1 = keys.map(t22);
    $[0] = keys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[3] !== ariaLabel || $[4] !== t1) {
    t2 = /* @__PURE__ */ jsx("span", { className: "graphiql-keycap-hint", "aria-label": ariaLabel, children: t1 });
    $[3] = ariaLabel;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export {
  KeycapHint,
  MODIFIER
};
//# sourceMappingURL=index.js.map
